/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 $('.main-carousel').flickity({
 // options
 cellAlign: 'left',
 contain: true,
 wrapAround: true,
 freeScroll: true,
 draggable: true,
 pageDots: false
});

(function($) {

  $('#myCarousel').carousel({
    interval: false
  })

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // List of sentences
        var _CONTENT = [
          "Marketing",
          "Sales",
          "Management"
        ];

        // Current sentence being processed
        var _PART = 0;

        // Character number of the current sentence being processed
        var _PART_INDEX = 0;

        // Holds the handle returned from setInterval
        var _INTERVAL_VAL;

        // Element that holds the text
        var _ELEMENT = document.querySelector("#text");

        // Cursor element
        var _CURSOR = document.querySelector("#cursor");

        // Implements typing effect
        function Type() {
          // Get substring with 1 characater added
          var text =  _CONTENT[_PART].substring(0, _PART_INDEX + 1);
          _ELEMENT.innerHTML = text;
          _PART_INDEX++;

          // If full sentence has been displayed then start to delete the sentence after some time
          if(text === _CONTENT[_PART]) {
            // Hide the cursor
            _CURSOR.style.display = 'none';

            clearInterval(_INTERVAL_VAL);
            setTimeout(function() {
              _INTERVAL_VAL = setInterval(Delete, 50);
            }, 3000);
          }
        }

        // Implements deleting effect
        function Delete() {
          // Get substring with 1 characater deleted
          var text =  _CONTENT[_PART].substring(0, _PART_INDEX - 1);
          _ELEMENT.innerHTML = text;
          _PART_INDEX--;

          // If sentence has been deleted then start to display the next sentence
          if(text === '') {
            clearInterval(_INTERVAL_VAL);

            // If current sentence was last then display the first one, else move to the next
            if(_PART == (_CONTENT.length - 1))
              _PART = 0;
            else
              _PART++;

            _PART_INDEX = 0;

            // Start to display the next sentence after some time
            setTimeout(function() {
              _CURSOR.style.display = 'inline-block';
              _INTERVAL_VAL = setInterval(Type, 100);
            }, 200);
          }
        }

        // Start the typing effect on load
        _INTERVAL_VAL = setInterval(Type, 100);

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
